'use client'
import { useState, useRef, useEffect } from "react";
import { TbCurrentLocation, IoIosSearch } from '@assets/Icons';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { getSuggetions } from "@api/services/newServices";
import services from '@api/services';
import { debounce, getNextDay } from "@utils/utils";
import { propertySeletor, setSearch, getRroomPropertyAction, setFilter } from "@store/slices/propertySlice";

const SearchBar = ({ locationData, nearByClick = () => { }, }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchRef = useRef(null);
    const toDateRef = useRef(null);
    const suggetionRef = useRef(null);
    const searchBarData = useRef(null);
    const { searchVal, filterValues } = useSelector(propertySeletor);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(getNextDay());
    const [suggetion, setSuggetion] = useState([]);
    const [onTopShow, setTopShow] = useState(false);
    const [searchType, setSearchType] = useState("");
    const [errorVal, setErrorVal] = useState(false);
    const [cities, setCities] = useState([]);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const fetchCities = async () => {
        try {
            const res = await services.globalService.getCities()
            if (res.status == 200) { setCities(res?.data?.data) }
        }
        catch (error) { console.log("Error in fetchCities function.") }
    }

    useEffect(() => { fetchCities() }, []);

    const formatNameWithLocality = (name = '', cities = []) => {
        if (typeof name != 'string' || !Array.isArray(cities)) return '';
        const parts = name.split(',').map(p => p.trim());
        if (parts.length < 2) return name.replace(/\s+/g, '-');
        const locality = parts[0];
        const cityCandidate = parts.slice(1).join(', ');
        const matchedCity = cities.find(c => c.name.toLowerCase() == cityCandidate.toLowerCase());
        const city = matchedCity ? matchedCity.name : cityCandidate;
        // return `${locality.replace(/\s+/g, '-')}-Locality-${city.replace(/\s+/g, '-')}`;
        return `${locality.replace(/\s+/g, '-')}-${city.replace(/\s+/g, '-')}`;
    };

    const onSubmit = async () => {
        if (searchVal.length <= 0) {
            setErrorVal(true);
            searchRef.current.focus();
            return;
        }
        let getFilterValuesData = { ...filterValues };
        if (getFilterValuesData.propertyCategoryFilter.length || getFilterValuesData.roomCategoryFilter.length || getFilterValuesData.localityFilter.length) {
            let propertyType = getFilterValuesData.propertyCategoryFilter.join(",");
            let roomType = getFilterValuesData.roomCategoryFilter.join(",");
            let pin = getFilterValuesData.localityFilter;
            dispatch(getRroomPropertyAction(`?order_direction=asc${pin ? `&pin_code=${pin}` : searchVal ? `&query=${searchVal}` : ""}${propertyType ? `&property_type=${propertyType}` : ""}${roomType ? `&room_type=${roomType}` : ""}`));
        }
        else { dispatch(getRroomPropertyAction(`?order_direction=asc${searchVal ? `&query=${searchVal}` : ""} `)); }
        let LSlug
        if (searchType == "LOCALITY") { LSlug = formatNameWithLocality(searchVal); }
        navigate(searchType == "LOCALITY" ? `best-hourly-hotels-in-${LSlug}` : `/best-hourly-hotels-in-${searchVal}`);
        // navigate(searchType == "LOCALITY" ? `best-hourly-hotels-in-${LSlug}` : searchVal == "lucknow" ? "hotels-in-lucknow" : `/best-hourly-hotels-in-${searchVal}`);
        dispatch(setFilter({ ...filterValues, localityFilter: '' }));
    };

    const searchFun = async (e) => {
        if (e.target.value.length <= 0) { setErrorVal(true); setSuggetion([]) }
        else { setErrorVal(false); }
        dispatch(setSearch(e.target.value));
        try {
            const sugg = await getSuggetions(e.target.value);
            if (sugg) { setSuggetion(sugg); }
        } catch (error) { console.log("Error in searchFun function") }
    };

    const changeHandler = debounce(searchFun, 2000);

    useEffect(() => {
        searchRef.current.value = searchVal;
        window.addEventListener("scroll", () => {
            let el = searchBarData.current;
            var _x = 0;
            var _y = 0;
            while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                _x += el.offsetLeft - el.scrollLeft;
                _y += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }
            const scrollTop = window.scrollY;
            if (_y < scrollTop) { setTopShow(true); }
            else { setTopShow(false); }
        });
    }, [locationData]);

    const handleSelect = (item) => {
        if (item?.type == "CITY") {
            dispatch(setSearch(item?.name));
            searchRef.current.value = item?.name;
        } else if (item?.type == "LOCALITY") {
            dispatch(setSearch(item?.name));
            dispatch(setFilter({ ...filterValues, localityFilter: `${item?.pin_code}` }));
            searchRef.current.value = item?.name;
            setSearchType(item?.type)
        } else {
            if (item?.city?.name == "Lucknow") { navigate(`/hotels-in-lucknow${item.slug}`); }
            else { navigate(`/hotel-details${item.slug}`); }
        }
        setSuggetion([]);
    }

    return (
        <div className="search-widget">
            <div className="column one">
                <span className="search-label text-dark">Where</span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by city, hotel, or neighborhood"
                    ref={searchRef}
                    onChange={(e) => { changeHandler(e); }}
                    onFocus={(e) => { changeHandler(e); }}
                    onKeyUp={(e) => { if (e.key == "Enter") { setSuggetion([]); } }}
                />
                {locationData?.latitude ? (
                    <button type="button" className="btn-mat btn-mat-secondary" onClick={nearByClick}>
                        <TbCurrentLocation size={16} className='mr-1' /> Near Me
                    </button>
                ) : null}
                {suggetion?.length > 0 && searchVal && (
                    <div ref={suggetionRef} id="sugg" className="search-suggestions" style={{ overflow: "auto", maxHeight: "50vh" }}>
                        <ul>
                            {suggetion?.map((item, ind) => {
                                const { name, pin_code, type } = item;
                                return (
                                    <li key={ind} onClick={() => handleSelect(item)}>
                                        <p className="searchSuggestionText">{name.length > 35 ? name.substring(0, 40) + "..." : name}</p>
                                        {item?.type == "PROPERTY" && <p className="fs-7 text-light">{item?.locality} {item?.city?.name}</p>}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )
                }
            </div>
            <div className="column two">
                <span className="search-label text-dark">Check-In</span>
                <DatePicker
                    className="form-control dataForm"
                    selected={fromDate}
                    dateFormat="dd/MM/yyyy"
                    value={fromDate}
                    minDate={new Date()}
                    onChange={(date) => { setFromDate(date); toDateRef.current.setFocus(true); }}
                />
            </div>
            <div className="column two">
                <span className="search-label text-dark">Check-Out</span>
                <DatePicker
                    ref={toDateRef}
                    className="form-control dataForm"
                    selected={toDate}
                    minDate={tomorrow}
                    dateFormat="dd/MM/yyyy"
                    value={toDate}
                    onChange={(date) => setToDate(date)}
                />
            </div>
            <div className="column three">
                <span className="search-label text-dark">Guests and rooms</span>
                <select className="form-control form-select">
                    <option>2 Adults, 2 Kids, 1 Room</option>
                    <option>2 Adults, 1 Kids, 2 Room</option>
                    <option>1 Adults, 2 Kids, 2 Room</option>
                </select>

                <button type='button' className='btn-action bg-primary' onClick={onSubmit}>
                    <span className="icon"><IoIosSearch size={22} /></span>
                    <span className="text">Search</span>
                </button>
            </div>
        </div>
    )
}

export default SearchBar;